import { render, staticRenderFns } from "./UserProfileGameAccountsList.vue?vue&type=template&id=58c32918&"
import script from "./UserProfileGameAccountsList.vue?vue&type=script&lang=ts&"
export * from "./UserProfileGameAccountsList.vue?vue&type=script&lang=ts&"
import style0 from "./UserProfileGameAccountsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VList,VListItemTitle,VSubheader})
